export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [20,[2]],
		"/(app)/admin": [21,[2,3]],
		"/(app)/admin/agents": [22,[2,3]],
		"/(app)/admin/application-material-access": [23,[2,3]],
		"/(app)/admin/capabilities": [24,[2,3]],
		"/(app)/admin/core-engine": [25,[2,3]],
		"/(app)/admin/customer-support": [26,[2,3]],
		"/(app)/admin/data-capacity": [27,[2,3]],
		"/(app)/admin/evaluations": [28,[2,3]],
		"/(app)/admin/functions": [29,[2,3]],
		"/(app)/admin/functions/create": [30,[2,3]],
		"/(app)/admin/functions/edit": [31,[2,3]],
		"/(app)/admin/organization-model": [32,[2,3]],
		"/(app)/admin/setmenu": [33,[2,3]],
		"/(app)/admin/settings": [34,[2,3]],
		"/(app)/admin/users": [35,[2,3]],
		"/(app)/admin/video-registry": [36,[2,3,4]],
		"/(app)/admin/video-registry/audit": [37,[2,3,4]],
		"/(app)/admin/video-registry/capabilities": [38,[2,3,4]],
		"/(app)/admin/video-registry/connections": [39,[2,3,4]],
		"/(app)/admin/video-registry/connections/new": [41,[2,3,4]],
		"/(app)/admin/video-registry/connections/[id]/edit": [40,[2,3,4]],
		"/(app)/admin/video-registry/health-cost": [42,[2,3,4]],
		"/(app)/admin/video-registry/models": [43,[2,3,4]],
		"/(app)/admin/video-registry/models/new": [44,[2,3,4]],
		"/(app)/admin/video-registry/overview": [45,[2,3,4]],
		"/(app)/admin/video-registry/protocols": [46,[2,3,4]],
		"/(app)/admin/video-registry/protocols/new": [47,[2,3,4]],
		"/(app)/admin/video-registry/releases": [48,[2,3,4]],
		"/(app)/admin/video-registry/routing": [49,[2,3,4]],
		"/(app)/admin/video-registry/tasks": [50,[2,3,4]],
		"/(app)/admin/wiki-profiles": [51,[2,3]],
		"/(app)/admin/wiki-profiles/[id]": [52,[2,3]],
		"/(app)/admin/workbench-native": [53,[2,3]],
		"/(app)/agents": [54,[2,5]],
		"/(app)/agents/[id]": [55,[2,5]],
		"/(app)/audio-transcription": [56,[2,6]],
		"/auth": [104],
		"/(app)/channels/[id]": [58,[2]],
		"/(app)/c/[id]": [57,[2]],
		"/error": [105],
		"/(app)/home": [59,[2,7]],
		"/(app)/image-generation-next": [61,[2,9]],
		"/(app)/image-generation": [60,[2,8]],
		"/(app)/knowledge": [62,[2,10]],
		"/(app)/knowledge/create": [64,[2,10]],
		"/(app)/knowledge/documents": [65,[2,10]],
		"/(app)/knowledge/files": [66,[2,10]],
		"/(app)/knowledge/materials": [67,[2,10]],
		"/(app)/knowledge/[id]": [63,[2,10]],
		"/(app)/me": [68,[2]],
		"/(app)/notes": [69,[2,11]],
		"/(app)/notes/[id]": [70,[2,11]],
		"/(app)/organization-model": [71,[2,12]],
		"/(app)/organization-model/invite": [72,[2,12]],
		"/(app)/personalapp": [73,[2,13]],
		"/(app)/personalapp/create": [74,[2,13]],
		"/(app)/personalapp/edit": [75,[2,13]],
		"/(app)/playground": [76,[2,14]],
		"/(app)/playground/completions": [77,[2,14]],
		"/(app)/ppt-generation": [78,[2,15]],
		"/(app)/setmenu": [79,[2,16]],
		"/(app)/setmenu/completions": [80,[2,16]],
		"/(app)/smart-operations": [81,[2,17]],
		"/(app)/smart-operations/home-video": [82,[2,17]],
		"/(app)/smart-operations/materials": [83,[2,17]],
		"/(app)/smart-operations/results/[id]": [84,[2,17]],
		"/(app)/smart-operations/skills-preview": [85,[2,17]],
		"/(app)/smart-operations/tasks": [86,[2,17]],
		"/(app)/smart-operations/xhs-note": [87,[2,17]],
		"/s/[id]": [106],
		"/(app)/video-generation": [88,[2,18]],
		"/watch": [107],
		"/(app)/workbench-native": [89,[2]],
		"/(app)/workspace": [90,[2,19]],
		"/(app)/workspace/functions/create": [91,[2,19]],
		"/(app)/workspace/knowledge": [92,[2,19]],
		"/(app)/workspace/knowledge/create": [94,[2,19]],
		"/(app)/workspace/knowledge/[id]": [93,[2,19]],
		"/(app)/workspace/models": [95,[2,19]],
		"/(app)/workspace/models/create": [96,[2,19]],
		"/(app)/workspace/models/edit": [97,[2,19]],
		"/(app)/workspace/prompts": [98,[2,19]],
		"/(app)/workspace/prompts/create": [99,[2,19]],
		"/(app)/workspace/prompts/edit": [100,[2,19]],
		"/(app)/workspace/tools": [101,[2,19]],
		"/(app)/workspace/tools/create": [102,[2,19]],
		"/(app)/workspace/tools/edit": [103,[2,19]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';